var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sync-panel sync-alert-page"
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('section', {
    staticClass: "alert-section"
  }, [_c('div', {
    staticClass: "alert-section-head alert-section-head--refreshable"
  }, [_c('div', {
    staticClass: "alert-section-head-main"
  }, [_c('h2', [_vm._v(` ${$t("6kc2ko7", "单位代码未匹配")} `), _c('span', {
    staticClass: "alert-count-badge alert-count-badge--danger"
  }, [_vm._v(" " + _vm._s(_vm.mismatchTotal) + ` ${$t("kf51", "条")} `)])]), _c('p', [_vm._v(` ${$t("npfi4v1j", "iWork 单位代码在目标系统中找不到，相关成员同步暂挂。单位映射由绿云运维处理，处理完成后您可在此批量重试。")} `)])]), _c('Icon', {
    staticClass: "alert-refresh-icon",
    class: {
      'ivu-load-loop': _vm.loading
    },
    attrs: {
      "size": "24",
      "type": "md-refresh"
    },
    on: {
      "click": _vm.refreshAlertPage
    }
  })], 1), _vm.mismatchGroups.length ? _c('div', {
    staticClass: "alert-group-list"
  }, _vm._l(_vm.mismatchGroups, function (group) {
    return _c('div', {
      key: group.key,
      staticClass: "alert-group-card"
    }, [_c('div', {
      staticClass: "alert-group-head"
    }, [_c('div', {
      staticClass: "alert-flow"
    }, [_c('span', {
      staticClass: "alert-unit-code"
    }, [_vm._v(_vm._s(group.unitCode))]), _c('Icon', {
      staticClass: "alert-flow-arrow",
      attrs: {
        "type": "md-arrow-forward"
      }
    }), _c('span', {
      staticClass: "alert-system-pill",
      class: _vm.systemPillClass(group.downstreamSystem)
    }, [_vm._v(" " + _vm._s(_vm.shortSystemName(group.downstreamSystem)) + " ")]), _c('span', {
      staticClass: "alert-impact"
    }, [_vm._v(" " + _vm._s(`${group.totalRows}${" " + $t('4o57z36', '个成员受影响') + ""}`) + " ")])], 1), _c('Button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "disabled": _vm.isGroupLoading(group),
        "loading": _vm.isGroupLoading(group)
      },
      on: {
        "click": function ($event) {
          return _vm.openBatchRetryConfirm(group);
        }
      }
    }, [_vm._v(" " + _vm._s((_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("sn57egq", "\u6279\u91CF\u91CD\u8BD5\uFF08${group.totalRows} \u6761\uFF09", {
      "group.totalRows": group.totalRows
    }))) + " ")])], 1), _c('div', {
      staticClass: "alert-group-tools"
    }, [_c('div', {
      staticClass: "alert-selection-tools"
    }, [_c('Checkbox', {
      attrs: {
        "value": _vm.isPageAllChecked(group),
        "indeterminate": _vm.isPageIndeterminate(group)
      },
      on: {
        "on-change": function ($event) {
          return _vm.togglePageSelection(group, $event);
        }
      }
    }, [_vm._v(` ${$t("av8qay4", "全选本页")} `)]), _c('span', [_vm._v(" " + _vm._s((_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("e4bukgs", "\u5DF2\u9009 ${selectedCount(group)} \u6761", {
      "selectedCount(group)": _vm.selectedCount(group)
    }))) + " ")]), _c('Button', {
      attrs: {
        "size": "small",
        "disabled": !_vm.selectedCount(group) || _vm.isGroupLoading(group),
        "loading": _vm.isGroupLoading(group)
      },
      on: {
        "click": function ($event) {
          return _vm.retrySelectedRows(group);
        }
      }
    }, [_vm._v(` ${$t("iz76r04", "重试选中")} `)])], 1)]), _c('Table', {
      staticClass: "alert-member-table alert-mismatch-table",
      attrs: {
        "columns": _vm.mismatchColumns,
        "data": _vm.groupPageRows(group),
        "disabled-hover": true
      },
      on: {
        "on-selection-change": function ($event) {
          return _vm.onGroupSelectionChange(group, $event);
        }
      }
    }), _c('div', {
      staticClass: "alert-group-footer"
    }, [_c('Page', {
      attrs: {
        "current": _vm.groupState(group).page,
        "page-size": _vm.groupState(group).pageSize,
        "total": group.totalRows,
        "size": "small",
        "transfer": "",
        "show-total": "",
        "show-sizer": ""
      },
      on: {
        "on-change": function ($event) {
          return _vm.changeGroupPage(group, $event);
        },
        "on-page-size-change": function ($event) {
          return _vm.changeGroupPageSize(group, $event);
        }
      }
    })], 1)], 1);
  }), 0) : _c('div', {
    staticClass: "alert-empty-card"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-checkmark-circle-outline"
    }
  }), _vm._m(0)], 1)]), _c('section', {
    staticClass: "alert-section alert-section--multiple"
  }, [_c('div', {
    staticClass: "alert-section-head"
  }, [_c('h2', [_vm._v(` ${$t("buci1z4", "多重匹配")} `), _c('span', {
    staticClass: "alert-count-badge alert-count-badge--warning"
  }, [_vm._v(" " + _vm._s(_vm.multipleTotal) + ` ${$t("kf51", "条")} `)])]), _c('p', [_vm._v(` ${$t("ekj3uj11", "目标系统中存在多个同名账号，无法自动唯一确定，需人工选择正确账号进行关联。")} `)])]), _vm.multipleRows.length ? _c('Table', {
    staticClass: "alert-member-table alert-multiple-table",
    attrs: {
      "columns": _vm.multipleColumns,
      "data": _vm.multipleRows,
      "disabled-hover": true
    }
  }) : _c('div', {
    staticClass: "alert-empty-card alert-empty-card--compact"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-checkmark-circle-outline"
    }
  }), _c('div', [_c('strong', [_vm._v($t("cy58f38", "暂无多重匹配告警"))]), _c('span', [_vm._v($t("7zecf9i", "当前没有需要人工选择候选账号的成员。"))])])], 1)], 1), _c('Modal', {
    attrs: {
      "title": $t("ng0sus6", "批量重试确认"),
      "class-name": "sync-batch-retry-confirm-modal"
    },
    on: {
      "on-cancel": _vm.closeBatchRetryConfirm
    },
    model: {
      value: _vm.batchRetryConfirm.visible,
      callback: function ($$v) {
        _vm.$set(_vm.batchRetryConfirm, "visible", $$v);
      },
      expression: "batchRetryConfirm.visible"
    }
  }, [_c('div', {
    staticClass: "batch-retry-confirm"
  }, [_c('div', {
    staticClass: "batch-retry-warning"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-alert-outline"
    }
  }), _c('span', [_vm._v(" " + _vm._s((_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("wqqn5o2x", "\u8BF7\u5148\u4E0E\u7EFF\u4E91\u8FD0\u7EF4\u786E\u8BA4 ${batchRetryConfirm.group ? batchRetryConfirm.group.unitCode : \"\u2014\"} \u5DF2\u5B8C\u6210\u5355\u4F4D\u6620\u5C04\uFF0C\u518D\u6267\u884C\u91CD\u8BD5\u3002\u672A\u6620\u5C04\u76F4\u63A5\u91CD\u8BD5\u5C06\u518D\u6B21\u5931\u8D25\u3002", {
    "batchRetryConfirm.group ? batchRetryConfirm.group.unitCode : \"\u2014\"": _vm.batchRetryConfirm.group ? _vm.batchRetryConfirm.group.unitCode : "—"
  }))) + " ")])], 1), _c('p', {
    staticClass: "batch-retry-result-tip"
  }, [_vm._v(` ${$t("70cyr2s", "重试结果将在同步日志中记录，若仍失败可再次查看告警详情。")} `)])]), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.batchRetryConfirm.saving
    },
    on: {
      "click": _vm.closeBatchRetryConfirm
    }
  }, [_vm._v(` ${$t("ev022", "取消")} `)]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchRetryConfirm.saving
    },
    on: {
      "click": _vm.confirmBatchRetry
    }
  }, [_vm._v(` ${$t("qn0pzo6", "确认批量重试")} `)])], 1)], 2), _c('Modal', {
    attrs: {
      "title": $t("wjwmk26", "手动选择账号"),
      "width": "680",
      "class-name": "sync-candidate-modal"
    },
    model: {
      value: _vm.candidateModal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.candidateModal, "visible", $$v);
      },
      expression: "candidateModal.visible"
    }
  }, [_c('div', {
    staticClass: "candidate-warning"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-alert-outline"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.candidateWarningText))])], 1), _vm.candidateModal.candidates.length ? _c('div', {
    staticClass: "candidate-list"
  }, [_c('div', {
    staticClass: "candidate-list-head"
  }, [_c('span', [_vm._v($t("l30kc3", "账号名"))]), _c('span', [_vm._v($t("ewbd43", "手机号"))]), _c('span', [_vm._v($t("pgxs2", "部门"))]), _c('span', [_vm._v($t("ar84e54", "创建时间"))])]), _c('RadioGroup', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: _vm.candidateModal.selectedKey,
      callback: function ($$v) {
        _vm.$set(_vm.candidateModal, "selectedKey", $$v);
      },
      expression: "candidateModal.selectedKey"
    }
  }, _vm._l(_vm.candidateModal.candidates, function (item, index) {
    return _c('Radio', {
      key: _vm.candidateKey(item, index),
      staticClass: "candidate-account-row",
      attrs: {
        "label": _vm.candidateKey(item, index)
      }
    }, [_c('div', {
      staticClass: "candidate-account-grid"
    }, [_c('OverflowTooltipText', {
      attrs: {
        "text": _vm.candidateAccountName(item),
        "max-width": 280,
        "text-class": "candidate-account-name",
        "tooltip-class": "candidate-account-name-tooltip",
        "tooltip-style": {
          display: 'block',
          width: '100%',
          minWidth: 0
        },
        "text-style": {
          color: '#111827',
          fontSize: '14px',
          fontWeight: 700
        }
      }
    }), _c('span', [_vm._v(_vm._s(item.mobile || "—"))]), _c('div', {
      staticClass: "candidate-department-cell",
      on: {
        "mousedown": function ($event) {
          $event.stopPropagation();
          $event.preventDefault();
        },
        "mouseup": function ($event) {
          $event.stopPropagation();
        },
        "click": function ($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('Tooltip', {
      staticClass: "candidate-department-tooltip",
      attrs: {
        "content": _vm.candidateDepartmentName(item),
        "placement": "top",
        "transfer": ""
      }
    }, [_c('span', {
      staticClass: "candidate-department"
    }, [_vm._v(" " + _vm._s(_vm.candidateDepartmentName(item)) + " ")])])], 1), _c('span', [_vm._v(_vm._s(_vm.candidateCreateDate(item.createDatetime)))])], 1)]);
  }), 1)], 1) : _c('div', {
    staticClass: "candidate-empty"
  }, [_vm._v($t("dcv57g4", "暂无数据"))]), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function ($event) {
        _vm.candidateModal.visible = false;
      }
    }
  }, [_vm._v(` ${$t("ev022", "取消")} `)]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.candidateModal.saving
    },
    on: {
      "click": _vm.manualBind
    }
  }, [_vm._v(` ${$t("frol9z4", "确认关联")} `)])], 1)], 2)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v($t("jmt5s6b", "暂无单位代码未匹配告警"))]), _c('span', [_vm._v($t("jhr9dzn", "当前下游系统没有因单位代码未匹配而暂挂的成员。"))])]);
}];
export { render, staticRenderFns };